import React, { useMemo } from 'react'

import { Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, string } from 'prop-types'

import AdultContentModal from 'Pods/ListingPage/Components/AdultContentModal/LazyAdultModal'
import ModelCard from 'Pods/ListingPage/Components/ModelCard/ModelCard'
import getModelsPerRow from 'Pods/ListingPage/Components/utils/getModelsPerRow'

import useBreakpoint from 'Utils/useBreakpoint'

import useCollectionGrid from './useCollectionGrid'
import useCollectionHubTracking from '../../Hooks/useCollectionHubTracking'

const noop = () => {}

function CollectionModelGrid({
  models,
  collectionSlug,
}) {
  const {
    cart,
    cartItemIds,
    setCartItemIds,
    wishListItems,
    setWishListItems,
    showGallery,
    handlePreviewClick,
    handleCloseGallery,
    viewerIsAdult,
    setViewerIsAdult,
    isAdultModalVisible,
    handleShowAdultModal,
    handleHideAdultModal,
    isIOSDevice,
    cardVisibilitySettings,
  } = useCollectionGrid()

  const currentBreakpoint = useBreakpoint()
  const modelsPerRow = getModelsPerRow(currentBreakpoint, 'medium')

  const { isReady: areTrackingUtilsAvailable } = useCollectionHubTracking({
    models,
    collectionSlug,
    itemsPerRow: modelsPerRow,
  })

  const contextValue = useMemo(() => ({
    isLoading: false,
    isTrackingInfoAvailable: true,
    areTrackingUtilsAvailable,
    selectedFilters: {},
  }), [areTrackingUtilsAvailable])

  if (!models || models.length === 0) {
    return null
  }

  return (
    <Context.Provider value={contextValue}>
      <div className="collections-grid">
        {models.map((model, index) => (
          <ModelCard
            key={model.id}
            {...model}
            cart={cart}
            modelIndex={index}
            listIndex={index}
            modelsPerRow={modelsPerRow}
            lastModelIndex={models.length - 1}
            showGallery={showGallery}
            onPreviewClick={handlePreviewClick}
            onCloseGallery={handleCloseGallery}
            viewerIsAdult={viewerIsAdult}
            showAdultModal={handleShowAdultModal}
            currentSelectedFileTypes={[]}
            setSelectedFilters={noop}
            trackFilterChange={noop}
            cardVisibilitySettings={cardVisibilitySettings}
            cardSizeSetting="medium"
            showCgtVerification
            setCartItemIds={setCartItemIds}
            cartItemIds={cartItemIds}
            wishListItems={wishListItems}
            setWishListItems={setWishListItems}
            gaList="collection"
            itemListId={collectionSlug}
            originalIndexes={[]}
            trackLastItemInView={noop}
            isIOSDevice={isIOSDevice}
            searchingFree={false}
            isSimilarSearchPossible={false}
            isSalesBoostEnabled={false}
          />
        ))}
      </div>
      {isAdultModalVisible && (
        <AdultContentModal setViewerIsAdult={setViewerIsAdult} hideAdultModal={handleHideAdultModal} />
      )}
    </Context.Provider>
  )
}

CollectionModelGrid.propTypes = {
  models: array.isRequired,
  collectionSlug: string.isRequired,
}

export default CollectionModelGrid
